import { render, staticRenderFns } from "./p17.vue?vue&type=template&id=54fcf67a&scoped=true&"
import script from "./p17.vue?vue&type=script&lang=js&"
export * from "./p17.vue?vue&type=script&lang=js&"
import style0 from "./p17.vue?vue&type=style&index=0&id=54fcf67a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcf67a",
  null
  
)

export default component.exports